import React, { useState } from 'react';
import { useIhsanRoll, setDutyOfficer } from '../lib/ihsanRollStore';
import { centerToast } from '../components/CenterToast';
import { ToolHeader } from './ihsanroll/shared';
import OfficerSheet from './ihsanroll/OfficerSheet';
import HomeView from './ihsanroll/HomeView';
import ResidentView from './ihsanroll/ResidentView';
import AttendanceView from './ihsanroll/AttendanceView';
import MovementView from './ihsanroll/MovementView';
import StatusView from './ihsanroll/StatusView';
import WhereaboutsView from './ihsanroll/WhereaboutsView';

const TITLES = {
  home: 'Daily Student Attendance',
  resident: 'Case',
  attendance: 'Attendance',
  movement: 'Movement',
  status: 'Status',
  whereabouts: 'Whereabouts'
};

export default function DailyStudentAttendance({ onBack }) {
  const [store, update] = useIhsanRoll();
  const [view, setView] = useState('home');
  const [caseNo, setCaseNo] = useState(null);
  const [pickerOpen, setPickerOpen] = useState(!store.dutyOfficer);

  const headerTitle =
    view === 'resident' && caseNo ? `Case #${caseNo}` : TITLES[view] || TITLES.home;

  const goBack = () => {
    if (view === 'home') {
      onBack?.();
      return;
    }
    if (view === 'whereabouts') {
      setView('home');
      return;
    }
    if (view === 'resident') {
      setCaseNo(null);
      setView('home');
      return;
    }
    setView('resident');
  };

  const openCase = (no, next = 'resident') => {
    setCaseNo(no);
    setView(next);
  };

  const pickOfficer = (name) => {
    update((prev) => setDutyOfficer(prev, name));
    setPickerOpen(false);
    centerToast(`${name} is on duty`, '🪪');
  };

  return (
    <div className="min-h-screen bg-background md:bg-[#F3F6F5] page-fade-in" data-testid="daily-attendance">
      <ToolHeader
        title={headerTitle}
        onBack={goBack}
        officer={store.dutyOfficer}
        onOfficer={() => setPickerOpen(true)}
      />

      <div className="md:max-w-[760px] md:mx-auto md:my-8 md:bg-white md:rounded-2xl md:shadow-lg md:border md:border-border/60 md:overflow-hidden">
        {view === 'home' && (
          <HomeView
            store={store}
            onOpenCase={(no) => openCase(no)}
            onWhereabouts={() => setView('whereabouts')}
          />
        )}
        {view === 'resident' && caseNo != null && (
          <ResidentView
            store={store}
            caseNo={caseNo}
            onAttendance={() => setView('attendance')}
            onMovement={() => setView('movement')}
            onStatus={() => setView('status')}
          />
        )}
        {view === 'attendance' && caseNo != null && (
          <AttendanceView
            store={store}
            caseNo={caseNo}
            update={update}
            onDone={() => {
              centerToast('Attendance saved', '✅');
              setView('resident');
            }}
          />
        )}
        {view === 'movement' && caseNo != null && (
          <MovementView
            store={store}
            caseNo={caseNo}
            update={update}
            onDone={() => {
              centerToast('Movement saved', '📍');
              setView('resident');
            }}
          />
        )}
        {view === 'status' && caseNo != null && (
          <StatusView store={store} caseNo={caseNo} update={update} />
        )}
        {view === 'whereabouts' && (
          <WhereaboutsView store={store} onOpenCase={(no) => openCase(no, 'movement')} />
        )}
      </div>

      {pickerOpen && (
        <OfficerSheet
          current={store.dutyOfficer}
          onPick={pickOfficer}
          onDismiss={() => store.dutyOfficer && setPickerOpen(false)}
        />
      )}
    </div>
  );
}
